import Form from "./form";

export class ContactForm {
    private componentName: string = 'ContactForm';

    public init() {
        this.subscribeForm();
    }

    private subscribeForm(): void {
        const formElement = document.querySelector(`[data-component=${this.componentName}] form`) as HTMLFormElement;

        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement,
            () => this.onSuccess(),
            (html: string) => this.onModelError(html));

        form.subscribeAndProcess();
    }

    private onSuccess(): void {
        this.displaySuccessMessage();
    }

    private onModelError(html: string): void {
        const viewcomponent = document.querySelector(`[data-component=${this.componentName}]`);
        viewcomponent.innerHTML = html;
        this.subscribeForm();
    }

    private displaySuccessMessage(): void {
        const successMessageElement = document.getElementById('success-message');
        const form = document.getElementById('contact-form');

        successMessageElement.style.display = 'block';
        form.style.display = 'none';
    }
}
